import { keepPreviousData, useQuery } from '@tanstack/react-query';

import type { CampaignQueryVariables, GetCampaignResponse } from '../types';
import { Mc3Client } from './client';
import { campaignQueryKeys } from './queryKeys';

/** MC3 campaigns API query string keys (snake_case). */
const CAMPAIGN_QUERY_PARAM_KEYS: Partial<
  Record<keyof CampaignQueryVariables, string>
> = {
  sortBy: 'sort_by',
  sortDir: 'sort_dir',
};

export function useCampaigns(variables: CampaignQueryVariables) {
  const { data, ...query } = useQuery({
    queryKey: campaignQueryKeys.list(variables),
    queryFn: async () => {
      const searchParams = new URLSearchParams();

      Object.entries(variables).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== '') {
          const paramKey =
            CAMPAIGN_QUERY_PARAM_KEYS[key as keyof CampaignQueryVariables] ??
            key;

          searchParams.append(paramKey, String(value));
        }
      });

      const response = await Mc3Client.get('api/campaigns', {
        searchParams,
      }).json<GetCampaignResponse>();

      return response;
    },
    placeholderData: keepPreviousData,
  });

  return {
    campaigns: data?.campaigns,
    totalCount: data?.total_count,
    ...query,
  };
}
